import React from 'react';
import { Spinner } from 'react-bootstrap';

import './index.scss';

interface MapEntry {
  key: string;
  title: string;
  badgeColor: string;
  badgeLabel: string;
  base64: string;
}

export interface SpatialMapsProps {
  observedData: string;
  climatology: string;
  anomaly: string;
  fetching: boolean;
}

export default function SpatialMaps({
  observedData,
  climatology,
  anomaly,
  fetching,
}: SpatialMapsProps) {
  // tema: dados-inicio — selos OBS/CLIM/ANOM: fundo forte com texto branco, legível nos dois temas
  const maps: MapEntry[] = [
    {
      key: 'observed', title: 'Dados Observados', badgeColor: '#17324E', badgeLabel: 'OBS', base64: observedData,
    },
    {
      key: 'climatology', title: 'Climatologia', badgeColor: '#3A7CBF', badgeLabel: 'CLIM', base64: climatology,
    },
    {
      key: 'anomaly', title: 'Anomalia', badgeColor: '#6B7480', badgeLabel: 'ANOM', base64: anomaly,
    },
  ];
  // tema: dados-fim

  return (
    <div className="observed-data-mobile-maps">
      {maps.map((map) => {
        if (!fetching && !map.base64) return null;
        return (
          <div key={map.key} className="observed-data-mobile-map-card">
            <div className="observed-data-mobile-map-card-header">
              <span className="observed-data-mobile-map-card-title">{map.title}</span>
              <span
                className="observed-data-mobile-map-card-badge"
                style={{ backgroundColor: map.badgeColor }}
              >
                {map.badgeLabel}
              </span>
            </div>
            {fetching ? (
              <div className="text-center py-4"><Spinner /></div>
            ) : (
              <img
                className="observed-data-mobile-map-card-image"
                src={`data:image/png;base64,${map.base64}`}
                alt={map.title}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
